import { SPONSOR_TIER, isSponsor } from '@/domain/center'
export const applyReverseTargeting = (center, currentContext) => {
  const id = center.pid || center.id
  const {
    term,
    location,
    reverseTargeting
  }: {
    term: {
      slug: string
    }
    location: {
      slug: string
    }
    reverseTargeting: {
      centerId: string
    }[]
  } = currentContext

  if (
    !center.sponsor_tier ||
    center.sponsor_tier >= 1000 ||
    !id ||
    !reverseTargeting
  ) {
    return center
  }

  const isCenterNegativeTargeted = reverseTargeting.find(
    (target) => target.centerId.toString() === id.toString()
  )
  if (!isCenterNegativeTargeted) {
    return center
  }

  return {
    ...center,
    sponsor_tier: SPONSOR_TIER.NOT_A_SPONSOR,
    card_size: 'Standard'
  }
}
